import { connect } from 'react-redux'
import RidersTablePane from '../../components/riders/RidersTablePane'
import { IStoreState } from '../../types'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    currentOrgId: state.organizations.currentOrgId
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RidersTablePane)



// WEBPACK FOOTER //
// ./src/containers/riders/RidersTablePane.ts